
















































































































































































































































/**
 * DrivePanel.vue — Locatelli SART (Vue 2 + TypeScript)
 *
 * Uso no SART index.vue:
 *   <DrivePanel :setor="client.setor" @context-ready="onDriveContext" />
 *
 * Evento emitido @context-ready:
 *   { docs: [{ id, name, content }], fullContext: string } | null
 *
 * O pai injeta fullContext no prompt enviado para /api/assistente-juridico.
 */
import Vue from 'vue'
import api from '@/helpers/fetch'

export default Vue.extend({
	name: 'DrivePanel',

	props: {
		/** Setor da empresa — dispara busca automática ao mudar */
		setor: { type: String, default: '' },
	},

	data() {
		return {
			documents: [] as any[],
			selectedIds: [] as string[],
			searchQuery: '',
			selectedSetor: '',
			searchResults: [] as any[],
			openFolders: {} as Record<string, boolean>,
			contextDocs: [] as any[],
			contextLoaded: false,
			contextPreview: false,
			totalChars: 0,
			loading: {
				list: false,
				search: false,
				content: false,
			},
			setores: [
				{ value: 'distribuicao', label: 'Distribuição' },
				{ value: 'alimentos', label: 'Alimentos' },
				{ value: 'construcao', label: 'Construção' },
				{ value: 'saude', label: 'Saúde' },
				{ value: 'transportes', label: 'Transportes' },
				{ value: 'ti', label: 'TI' },
				{ value: 'agronegocio', label: 'Agronegócio' },
				{ value: 'energia', label: 'Energia' },
				{ value: 'telecom', label: 'Telecom' },
				{ value: 'farmaceutico', label: 'Farmacêutico' },
				{ value: 'industria', label: 'Indústria' },
				{ value: 'mineracao', label: 'Mineração' },
			],
		}
	},

	computed: {
		contextSnippet(): string {
			if (!this.contextDocs.length) return ''
			const first = this.contextDocs[0]
			return `=== ${first.name} ===\n${(first.content || '').slice(0, 600)}…`
		},
	},

	watch: {
		setor(val: string) {
			if (val) {
				this.selectedSetor = val
				this.autoSearch()
			}
		},
	},

	mounted() {
		this.loadDocuments()
		if (this.setor) this.selectedSetor = this.setor
	},

	methods: {
		async loadDocuments() {
			this.loading.list = true
			try {
				const data = await api.get('/api/sart/drive/list')
				this.documents = data.files || []
				this.documents.forEach((f: any) => {
					if (f.isFolder) this.$set(this.openFolders, f.id, true)
				})
			} catch (e) {
				console.error('[DrivePanel] loadDocuments:', e)
			} finally {
				this.loading.list = false
			}
		},

		async autoSearch() {
			const q = this.searchQuery.trim()
			const s = this.selectedSetor
			if (!q && !s) return

			this.loading.search = true
			this.searchResults = []
			try {
				const data = await api.post('/api/sart/drive/search', {
					keywords: q ? q.split(/\s+/) : [],
					setor: s || undefined,
					maxResults: 6,
				})
				this.searchResults = data.files || []
			} catch (e) {
				console.error('[DrivePanel] autoSearch:', e)
			} finally {
				this.loading.search = false
			}
		},

		isSelected(id: string): boolean {
			return this.selectedIds.includes(id)
		},

		selectAll(docs: any[]) {
			docs.forEach((d) => {
				if (!this.isSelected(d.id)) this.selectedIds.push(d.id)
			})
			this.onSelectionChange()
		},

		clearSelection() {
			this.selectedIds = []
			this.contextLoaded = false
			this.contextDocs = []
			this.$emit('context-ready', null)
		},

		onSelectionChange() {
			if (this.contextLoaded) {
				this.contextLoaded = false
				this.$emit('context-ready', null)
			}
		},

		async loadContext() {
			if (!this.selectedIds.length) return
			this.loading.content = true
			try {
				const data = await api.post('/api/sart/drive/content', {
					fileIds: this.selectedIds,
					maxCharsPerDoc: 8000,
				})
				this.contextDocs = data.docs || []
				this.totalChars = this.contextDocs.reduce(
					(a: number, d: any) => a + d.charCount,
					0,
				)
				this.contextLoaded = true
				this.contextPreview = true

				const fullContext = this.contextDocs
					.map(
						(d: any) =>
							`=== DOCUMENTO: ${d.name} ===\n${d.content}`,
					)
					.join('\n\n---\n\n')

				this.$emit('context-ready', {
					docs: this.contextDocs,
					fullContext,
				})
			} catch (e) {
				console.error('[DrivePanel] loadContext:', e)
			} finally {
				this.loading.content = false
			}
		},

		toggleFolder(id: string) {
			this.$set(this.openFolders, id, !this.openFolders[id])
		},

		toggleSetor(val: string) {
			this.selectedSetor = this.selectedSetor === val ? '' : val
			if (this.selectedSetor) this.autoSearch()
			else this.searchResults = []
		},

		mimeLabel(mime: string): string {
			const map: Record<string, string> = {
				'application/vnd.google-apps.document': 'Google Doc',
				'application/pdf': 'PDF',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
					'Word',
				'text/plain': 'TXT',
			}
			return map[mime] || mime?.split('/').pop() || '?'
		},

		formatDate(iso: string): string {
			if (!iso) return ''
			return new Date(iso).toLocaleDateString('pt-BR', {
				day: '2-digit',
				month: 'short',
				year: 'numeric',
			})
		},
	},
})
